<template>
    <div class="home-case-study relative w-full h-screen overflow-hidden" >
        <div class="home-case-study__content" @mousemove="mouseenter" @mouseleave="mouseleave">
            <router-link v-if="client" :to="'/casestudy/' + slug" class="flex justify-center content-center">
                <div class="home-case-study__numbers-container h-screen overflow-hidden z-10">
                    <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" :viewBox="'0 0 '+ numberWidth+' 900'" class="home-case-study__numbers h-screen mx-auto z-10" >
                        <mask id="mask" v-html="number"></mask>
                        <filter id="distortionFilter">
                            <feTurbulence ref="turbulence" type="fractalNoise" baseFrequency="0.01 0.003" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise"/>
                            <feDisplacementMap ref="displacementMap" in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse"/>
                        </filter>
                        <image :xlink:href="image[0].url" :width="image[0].width" :height="image[0].height" :style="'filter:url(#distortionFilter); -webkit-mask : url(#mask); mask : url(#mask);'"/>
                    </svg>
                </div>

                <div class="home-case-study__client-container z-20">
                    <div class="home-case-study__client-content overflow-hidden z-20">
                        <h2 ref="client" class="home-case-study__client font-coign-bold text-black text-15xl md:text-20xl leading-none tracking-minwide uppercase whitespace-no-wrap text-center z-20"><span class="home-case-study__client-text">{{ client }}</span></h2>
                    </div>
                </div>
            </router-link>
            <div v-if="!client" class="home-case-study__numbers-container overflow-hidden">
                <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" viewBox="0 0 787.83 900" class="home-case-study__numbers h-screen mx-auto" >
                    <mask id="mask" v-html="number"></mask>
                    <filter id="distortionFilter">
                        <feTurbulence ref="turbulence" type="fractalNoise" baseFrequency="0.01 0.003" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise"/>
                        <feDisplacementMap ref="displacementMap" in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse"/>
                    </filter>
                    <image :xlink:href="image[0].url" :width="image[0].width" :height="image[0].height" :style="'filter:url(#distortionFilter); -webkit-mask : url(#mask); mask : url(#mask);'"/>
                </svg>
            </div>

            <div v-if="!client" class="home-case-study__client-container">
                <div class="home-case-study__client-content overflow-hidden">
                    <h2 ref="client" class="home-case-study__client font-coign-bold text-black text-8xl md:text-20xl leading-none tracking-minwide uppercase whitespace-no-wrap text-center"><span class="home-case-study__client-text">{{ client }}</span></h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {TweenMax, Power3 } from 'gsap';

    export default {
        props : {
            number : {
                type : String,
                default : ''
            },
            numberWidth : {
                type : Number,
                default : 800
            },
            client : {
                type : String,
                default : ''
            },
            slug : {
                type : String,
                default : ''
            },
            image : {
                type : Array,
                default : () => {}
            }
        },

        data() {
            return {
                moveCount : 20,

                filterVelocity : 2
            }
        },

        computed : {
            pageUrl(){
                return window.location.href;
            }
        },

        mounted(){
            document.querySelector('.home-case-study__client-text').setAttribute('data-width', document.querySelector('.home-case-study__client').clientWidth);

            TweenMax.to(document.querySelector('.home-case-study'), 0.5,{
                opacity : 1
            });
        },

        methods : {

            // Hover event
            mouseenter(){
                // If we have a svg filter
                if(this.$refs.displacementMap){
                    // Update the scale value
                    TweenMax.to(this.$refs.displacementMap.scale , 0.2, {
                        baseVal : this.moveCount
                    });

                    // Update the scale value
                    TweenMax.to(this.$refs.displacementMap.scale , 0.2, {
                        baseVal : this.moveCount
                    });

                    // Update the value
                    this.moveCount += this.filterVelocity;
                }
            },

            // Blur event
            mouseleave(){
                // If we have a svg filter
                if(this.$refs.displacementMap){
                    // Reset its scale value
                    TweenMax.to(this.$refs.displacementMap.scale , 0.7, {
                        baseVal : 0,
                        ease : Power3.easeOut
                    });
                }

                // Reset the base value
                this.moveCount = 20;
            },

            /**
             * Show the case study
             * @param pDone
             */
            caseStudyEnter(pDone){
                // Wait for virtual dom to be gone
                Vue.nextTick(() => {
                    // Get the text width
                    var textWidth = document.querySelector('.home-case-study__client-text').getAttribute('data-width');

                    // Show the numbers
                    TweenMax.fromTo(document.querySelector('.home-case-study__numbers-container'), 1, {
                        y : '100%'
                    },{
                        y : '0%',
                        force3D : false,
                        ease : Power3.easeOut,
                        onComplete : () => {
                            if(textWidth === 0) {
                                pDone();
                            }
                        }
                    });

                    TweenMax.fromTo(document.querySelector('.home-case-study__numbers'),1, {
                        y : '-100%'
                    },{
                        y : '0%',
                        force3D : false,
                        ease : Power3.easeOut
                    });

                    // Show the text
                    TweenMax.to(document.querySelector('.home-case-study__client'), 1,{
                        x : '0%',
                        delay : 0.3,
                        force3D : false,
                        ease : Power3.easeOut
                    });

                    TweenMax.to(document.querySelector('.home-case-study__client-content'), 1,{
                        x : '0%',
                        delay : 0.3,
                        force3D : false,
                        ease : Power3.easeOut,
                        onComplete : () => {
                            pDone();
                        }
                    });
                });
            },

            /**
             * Hide the case study
             * @param pDone
             */
            caseStudyLeave(pDone, pDuration){

                if(document.querySelector('.home-case-study__numbers')) {
                    // Hide the numbers
                    TweenMax.to(document.querySelector('.home-case-study__numbers-container'), (pDuration) ? pDuration : 1, {
                        y : '100%',
                        force3D : false,
                        ease : Power3.easeOut,

                    });

                    TweenMax.to(document.querySelector('.home-case-study__numbers'),(pDuration) ? pDuration : 1, {
                        y : '-100%',
                        force3D : false,
                        ease : Power3.easeOut,
                        onComplete : () => {
                            pDone();
                        }
                    });
                }

                if(document.querySelector('.home-case-study__client-text')){

                    TweenMax.to(document.querySelector('.home-case-study__client'), 1,{
                        x : '-100%',
                        delay : 0.3,
                        force3D : false,
                        ease : Power3.easeOut
                    });

                    // Hide the text
                    TweenMax.to(document.querySelector('.home-case-study__client-content'), (pDuration) ? pDuration : 1,{
                        x : '100%',
                        delay : 0.3,
                        force3D : false,
                        ease : Power3.easeOut,
                        onComplete : () => {
                            pDone();
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/styles/_globals.scss";

    .home-case-study {
        opacity : 0;

        &__numbers-container {
            @include top-left(0, 50%);
            transform : translate(-50%, 100%);
        }

        &__numbers{
            transform : translateY(-100%);
        }

         &__client-container {
            @include top-left(50%, 50%);
            transform : translate(-50%, -50%);
        }

        &__client-content {
            transform : translateX(100%);
        }

        &__client{
            transform : translateX(-100%);
            @include responsive-font(30vw, 30vw, 31.25rem, 31.25rem);

            @include letter-spacing-and-text-align-center(0.04em);
        }
    }
</style>